import React from "react";
import { Link } from "react-router-dom";

const pages = [
  { page: "About Us", path: "/about-us" },
  { page: "Services", path: "/service" },
  { page: "Products", path: "/product" },
  { page: "Contact Us", path: "/contact-us" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-color">
      <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <div className="grid grid-cols-1  sm:grid-cols-4 md:grid-cols-5 gap-10 md:gap-0">
          <div className=" md:mb-0 flex flex-col items-center justify-between">
            <a href="" className="flex items-center mb-2 flex-col">
              <img
                src={require("../assets/h2a 3.png")}
                className="h-18"
                alt="H2A Logo"
              />
            <p className="text-gray-400">
              Health to All
            </p>
            </a>
          </div>
          <div className=" sm:border-l-2 border-gray-color ">
            <div className=" h-full flex flex-col gap-3 items-center justify-between">
              <ul className="h-full flex flex-col gap-2 items-center md:items-start justify-between">
                {pages.map((p, index) => (
                  <li key={index}>
                    <Link to={p.path}>{p.page}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="h-full flex flex-col  md:border-l-2 border-gray-color w-full order-4 sm:col-span-3 md:col-span-1 md:order-3">
            <div className="flex flex-col md:w-[55%] md:m-auto gap-3 sm:w-1/2 sm:m-auto sm:text-center md:text-left text-center   ">
              <h2 className=" text-lg font-semibold">Head Office</h2>
              <p className=" text-sm font-normal text-gray-800">
           Pyramids Heights business park Km 22 Cairo, Alexandria Desert Rd, Giza, Egypt
Giza, EG
              </p>
            </div>
          </div>

          <div className="order-3 md:order-4 sm:border-l-2 md:border-gray-color">
            <ul className="h-full flex flex-col gap-3 font-normal md:items-start items-center mx-10 text-center sm:text-left">
        
              <li className="mb-4">
                <h6 className="text-sm">Email</h6>
                <p className="font-medium">info@h2amedics.com</p>
              </li>
              <li className="mb-4 mx-0">
                <h6 className="text-sm">Phone</h6>
                <p className="font-medium">+201203000028 </p>
              </li>
            </ul>
          </div>
                    <div className="order-3 md:order-4 sm:border-l-2 md:border-gray-color">
                <img
                  src={require("../assets/partnerPhillips.jpg")}
                  className="h-24 m-auto"
                  alt="H2A QR Code"
                />
          </div>
        </div>
      </div>
    </footer>
  );
}
